import Vue from 'vue'
import axios from 'axios'
import { getBodyJava, getBodyJavaNew, queryToObj } from '@/untils/salt' // 验签核心方法
import '@/components/FbToast/toast.scss'
import Toast from '@/components/FbToast'
import store from 'store'
import getAccessToken from '@/untils/getAccessToken'
import { getRandomString } from '@/untils/util'
import logger from './logger'

// Toast 依赖
Vue.use(Toast, {
  type: 'center',
  duration: 1500
})
let _vm = Vue.prototype

let CancelToken = axios.CancelToken
// 创建axios实例
let requestId = ''
const service = axios.create({
  baseURL: '/api/merchant/newgateway',
  timeout: 80000,
  withCredentials: true,
  noErrorMsg: false, // 不需要全局拦截错误时，请求时参数传true
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})
// 微信点击分享消息不需要校验所以不用去获取token
const notToken = [
  'com.fshows.lifecircle.cms.share.news.detail',
  'com.fshows.lifecircle.cms.share.news.manual.update.data',
  'com.fshows.lifecircle.share.pay.customer.list'
]
// request拦截器
service.interceptors.request.use(
  async config => {
    config.startTimeMs = new Date().getTime()
    // console.log('请求的参数：', config)
    let accessToken = (store.getters.accessToken && store.getters.accessToken.length) ? store.getters.accessToken : localStorage.getItem('access_token')
    console.log(accessToken, 'accessToken')
    if (config.baseURL === '/api/merchant/newgateway' || config.baseURL === '/api/qrordering/app/gateway') {
      config.data = getBodyJavaNew(config.javaMethods, config.data || {})
      if (notToken.indexOf(config.javaMethods) === -1 && !accessToken) {
        console.log('获取token')
        accessToken = await getAccessToken()
      }
      requestId = getRandomString()
      config.headers['accessToken'] = accessToken
      config.headers['requestId'] = requestId
    } else {
      config.data = getBodyJava(config.javaMethods, config.data || {})
    }
    // 对于特定的需要取消上一个请求的做CancelToken处理
    if (config.hasCancelToken) {
      let requestName = `${config.url}&${config.javaMethods}`
      if (axios[requestName] && axios[requestName].cancel) {
        axios[requestName].cancel({ errMessage: '同一时间请勿重复请求', errorCode: 10000 })
      }
      config.cancelToken = new CancelToken((c) => {
        axios[requestName] = {}
        axios[requestName].cancel = c
      })
    }
    return config
  },
  error => {
    // Do something with request error
    // store.commit("loading", { loading: false });
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    let RequestParams = queryToObj(response.config.data) || {}
    const { method, content } = RequestParams
    const endTimeMs = new Date().getTime() // 请求结束时间
    let logerData = {
      ApiMethod: method,
      ApiRequest: content,
      // RequestParams,
      ApiDuration: `${endTimeMs - response.config.startTimeMs}ms`,
      RequestId: requestId,
      TraceId: requestId
    }
    // console.log('回调的参数1：', response, logerData)
    // setTimeout(() => {
    // store.commit("loading", { loading: false });
    // }, 300)
    if (response.config.noErrorMsg || res.success) {
      if (logerData) {
        logger.info({
          ...logerData,
          ApiResponse: { ...res } },
        'OBJECT'
        )
      }
      return res
    } else if (!res.success) {
      if (logerData) {
        res.success ? logger.info({
          ...logerData,
          ApiResponse: { ...res } },
        'OBJECT'
        ) : logger.error({
          ...logerData,
          ApiResponseError: { ...res }
        }, 'OBJECT')
      }
      console.log('接口报错：', res)
      if (res.errorCode === '1000' || res.errorCode === '1515') { // 用户信息不正确，重新登录
        let expireData = {
          code: res.errorCode,
          message: '登录失效，请重新登录'
        }
        console.log('===接口登录异常=store.getters.accessToken,localStorage====>', res, store.getters.accessToken, localStorage.getItem('access_token'))
        // _vm.$FbToast('登录失效，请重新登录')
        _vm.$jfs.toReStartLogin(expireData)
        return
      }
      if (!response.config.customToast) {
        _vm.$FbToast(res.errorMsg)
      }
      if (response.config.customToast) {
        return Promise.reject(res)
      }
    } else if (res.success && response.config.loggerSuc) { // 成功日志
      logerData && logger.info({
        ...logerData,
        Content: JSON.stringify(res)
      }, 'OBJECT')
    }
    return res
  },
  error => {
    console.log(error, 'eeeeeeeee')
    let logerData = {
      RequestId: requestId,
      TraceId: requestId,
      ApiResponseError: error
    }
    logger.error(logerData, 'OBJECT')
    // store.commit("loading", { loading: false });
    return Promise.reject(error)
  }
)

export default service
